import { Layout } from "providers/Layout";
import { QuestionsSlice } from "./slices/questions";
import { Show } from "shared/components/helpers/Show";
import { useSurveyStore } from "./store";
import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { landlordSurveyApi } from "api/landlord-surveys/landlord-surveys";
import { useParams } from "react-router-dom";
import { Loader } from "shared/components/Loader";
import { useAuthContext } from "providers/Auth";
import { Redirect } from "shared/components/Redirect";
import { LayoutHeader } from "./components/LayoutHeader";
import { blankTemplate, View } from "./constants";
import { ConditionsSlice } from "./slices/conditions";

export const LandlordSurveysIdView = () => {
  const { type } = useAuthContext();
  const isAvailable = type.isBoomScreen;
  const { id } = useParams();
  const resetApiData = useSurveyStore((state) => state.resetApiData);
  const isCreateMode = id === "add";

  const [view, setView] = useState<View>(View.Questions);

  useEffect(() => {
    if (isCreateMode) resetApiData(blankTemplate);
  }, [isCreateMode]);

  const { data, isLoading, isError } = useQuery({
    queryFn: async () => {
      if (!id) throw new Error("Missing identifier");

      const data = await landlordSurveyApi.getSurveyByIdentifier(id);
      resetApiData(data);
      return data;
    },
    queryKey: ["LANDLORD_SURVEYS", id],
    enabled: Boolean(id) && Boolean(isAvailable) && !isCreateMode
  });

  if (!isAvailable) return <Redirect href="/" />;
  // The Boom standard survey is read-only: partners duplicate it to change it.
  if (data?.boom_standard) return <Redirect href="/landlord-surveys" />;
  if (isError) return <Layout>Not found</Layout>;
  if (isLoading && !isCreateMode)
    return (
      <Layout>
        <Loader />
      </Layout>
    );
  return (
    <Layout
      header={<LayoutHeader view={view} setView={setView} />}
      headerClassName="!p-0"
      sectionClassName="!p-0"
    >
      <Show if={view === View.Questions}>
        <QuestionsSlice />
      </Show>

      <Show if={view === View.Conditions}>
        <ConditionsSlice />
      </Show>
    </Layout>
  );
};
